import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import MediaList from '../components/MediaList';

const Media = () => {
  return (
    <Layout subtitle="Manage your media files" sidebar={<Sidebar />}>
      <MediaList />
    </Layout>
  );
};

export default Media;
